'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSendFromResponders = undefined;

var _reselect = require('reselect');

var _buildSendFromResponders = require('conversations-schema/operators/widget-data/buildSendFromResponders');

var _getWidgetData = require('../../selectors/widgetDataSelectors/getWidgetData');

var getSendFromResponders = exports.getSendFromResponders = (0, _reselect.createSelector)([_getWidgetData.getWidgetData], _buildSendFromResponders.buildSendFromResponders);


//////////////////
// WEBPACK FOOTER
// ./js/responders/selectors/getSendFromResponders.js
// module id = 510
// module chunks = 2 3